export default class Analytics {

  constructor(options = {})
  {

    // Options
    options.type = options.type || 'Google Analytics'; // Or Matomo

    if (options.type == 'Google Analytics' && !options.id) {
      console.error('No ID set for Google Analytics Tracking');
      return false;
    }

    if (options.type == 'Matomo' && !options.id) {
      console.error('No ID set for Matomo Tracking');
      return false;
    }

    if (options.type == 'Matomo' && !options.url) {
      console.error('No URL set for Matomo Tracking');
      return false;
    }

    this.type = options.type;
    this.id = options.id;
    this.url = options.url;
  }

  track(to = null, location = null){

    if (typeof window.gtag === 'undefined') {
      var s = document.createElement("script");
      s.type = "text/javascript";
      s.async = "async";
      s.src = "https://www.googletagmanager.com/gtag/js?id="+this.id;
      document.head.appendChild(s);
      window.dataLayer = window.dataLayer || [];
      window.gtag = function(){dataLayer.push(arguments);}
    }

    let config = {
      'anonymize_ip':!0
    }
    if (to && location){
      config =
      {
        'anonymize_ip':!0,
        'page_path': location.pathname,
        'page_title': to.page.title,
        'page_location': location.href
      };
    }

    window.gtag('js', new Date());
    window.gtag('config', this.id , config);

  }

}
